import { Badge as AntBadge } from 'antd'
import styled from 'styled-components'

export const Badge = styled(AntBadge)`
  && {
    height: 20px;
    line-height: 20px;
    .ant-badge-status-dot {
      width: 12px;
      height: 12px;
      &.ant-badge-status-default {
        background-color: ${(props) => props.theme.colors.primary};
      }
      &.ant-badge-status-error {
        background-color: ${(props) => props.theme.colors.error};
      }
      &.ant-badge-status-warning {
        background-color: ${(props) => props.theme.colors.tag.warning};
      }
      &.ant-badge-status-success {
        background-color: ${(props) => props.theme.colors.success};
      }
    }
  }
`

export const TabsBadge = styled(AntBadge)`
  && {
    .ant-scroll-number {
      background-color: rgba(141, 141, 141, 0.12);
      color: ${(props) => props.theme.colors.text};
      box-shadow: none;
      height: 16px;
      line-height: 16px;
      padding: 0 4px;
      font-weight: 600;
    }
  }
`
